export default class ConsumerFinancingPreference {
  constructor(yearsOfLoan, interestRate) {
    this.yearsOfLoan = yearsOfLoan;
    this.interestRate = interestRate;
  }
}
